import { useState } from 'react';

/**
 * State for the <Honeypot /> field. Kept in its own module so Honeypot.tsx
 * exports only a component (react-refresh/only-export-components).
 *
 * Returns the current value plus the props to spread onto <Honeypot />. Pass
 * `value` to the submit call as its `hp` argument.
 */
export function useHoneypot() {
  const [value, setValue] = useState('');
  return { value, honeypotProps: { value, onChange: setValue } };
}
